/**
 * The authored colour-tile atlas.
 *
 * It is intentionally separate from the legacy CP437 glyph atlas while the
 * client moves from character-based looks to semantic tile lookups. Tile
 * names, never display characters, are the stable interface: the art includes
 * several distinct tiles that once shared a glyph.
 */
export const TILE_CELL = { width: 16, height: 24 };
export const TILE_ATLAS = {
    columns: 8,
    rows: 5,
    tiles: 38,
};
export const TILE_ATLAS_PATH = 'assets/annwn-tiles-16x24.png';
const TILE_NAMES = [
    'terrain.void',
    'terrain.grass',
    'terrain.grass.sparse',
    'terrain.dirt',
    'terrain.dirt.sparse',
    'terrain.bracken',
    'terrain.thicket',
    'terrain.water',
    'terrain.water.rough',
    'terrain.path',
    'terrain.ford',
    'terrain.tree.oak',
    'terrain.tree.pine',
    'terrain.rock',
    'terrain.scree',
    'terrain.crag',
    'terrain.wall',
    'terrain.mound',
    'site.door',
    'site.hearth',
    'site.well',
    'site.menhir',
    'site.cauldron',
    'sign.print',
    'sign.trail',
    'sign.droppings',
    'sign.blood',
    'flora.standing',
    'flora.picked',
    'actor.carcass.red',
    'actor.carcass.gold',
    'actor.carcass.grey',
    'actor.carcass.green',
    'actor.player.bone',
    'actor.player.blue',
    'actor.player.violet',
    'actor.creature',
    'ui.cursor',
];
const BY_NAME = new Map(TILE_NAMES.map((name, index) => [name, index]));
/** Atlas index for an authored tile. Unknown names are deliberately blank. */
export function tile(name) {
    return BY_NAME.get(name) ?? 0;
}
/** Name of an atlas cell, for editors and inspector tooling. */
export function tileName(index) {
    return TILE_NAMES[index];
}
//# sourceMappingURL=tiles.js.map